import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import DeleteIcon from "@material-ui/icons/Delete";
import EmojiFoodBeverageOutlinedIcon from "@material-ui/icons/EmojiFoodBeverageOutlined";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

export default function ItemChipsContainer({
  selectedItems,
  storeItems,
  deleteSelectedItem,
  deleteAll,
}) {
  const classes = useStyles();

  const handleDelete = (id) => {
    deleteSelectedItem(id);
  };
  const removeAll = () => {
    deleteAll([]);
  };

  return (
    <div style={{ marginBottom: "10px" }}>
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        {selectedItems.length ? (
          <a
            style={{
              color: "black",
              textDecoration: "none",
              fontSize: "14px",
              marginRight: "10px",
            }}
          >
            Applied Filters:
          </a>
        ) : null}

        {selectedItems.map((id) => {
          const found = storeItems.find((item) => item.id === id);

          return (
            <div className={classes.root}>
              <Chip
                label={found.title}
                onDelete={() => handleDelete(found.id)}
                color="secondary"
                variant="outlined"
              />
            </div>
          );
        })}
      </div>
      <br />
      {selectedItems.length ? (
        <Chip
          icon={<DeleteIcon />}
          label="Remove All Filters"
          onClick={removeAll}
          color="primary"
          variant="outlined"
        />
      ) : null}
    </div>
  );
}
